import React, { useState } from "react";
import "./PhoneCaptureModal.css";

export default function PhoneCaptureModal({ isOpen, email, onSubmit, isSubmitting = false }) {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const normalizedPhone = (phone || "").trim();
    if (!normalizedPhone) {
      setError("Phone number is required");
      return;
    }
    onSubmit(normalizedPhone);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="phone-capture-overlay">
      <div className="phone-capture-modal">
        <h2>Complete Your Trial Account</h2>
        <p>To get started with your 30-day free trial, please provide your phone number.</p>
        <form onSubmit={handleSubmit} className="phone-capture-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" value={email} disabled className="form-input" />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
                setError("");
              }}
              placeholder="+1 (555) 000-0000"
              className="form-input"
              disabled={isSubmitting}
            />
          </div>
          {error && <div className="form-error">{error}</div>}
          <div className="form-actions">
            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
              {isSubmitting ? "Saving..." : "Start Free Trial"}
            </button>
          </div>
          <p className="form-note">
            We'll use this number to verify your account and send important trial updates.
          </p>
        </form>
      </div>
    </div>
  );
}
